// Mirrors MoodPlayer's RemoteControlView, which the panel polls straight from the MoodPlayer backend.
interface MoodView {
    online: boolean;
    openPlaylists: MoodPlaylist[];
    activePlaylistId: string | null;
    volumePercent: number;
    volumeStepPercent: number;
    currentSongTitle: string | null;
    currentSongArtist: string | null;
    currentSongAlbum: string | null;
    isPlaying: boolean;
}
